import DrawerSectionHeading from 'components/DrawerSectionHeading';
import DefinitionTooltip from 'components/DefinitionTooltip';
import Stack from 'components/Stack';
import styled from 'styled-components';
import { tooltips } from '@/copy';

export const DimensionIconTag = styled(Stack).attrs(
    ({ $direction = 'row', $space = '.25em' }) => ({
        $direction,
        $space,
    }),
)`
    font-weight: ${({ theme }) => theme.fontSemiBold};
    text-transform: capitalize;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.gray_3};
`;

export const DrawerStack = styled(Stack)`
    padding: 0 1rem;
`;

export const TikTokDrawerTimeSeriesWrapper = styled.div`
    background-color: ${({ theme }) => theme.gray_6};
    border-width: 1px 0;
    border-color: ${({ theme }) => theme.gray_5};
    border-style: solid;
    padding-right: 0;
`;

export function SectionHeading(props) {
    return <DrawerSectionHeading className="my-6" {...props} />;
}

export function HashtagsWrapper(props) {
    return <div {...props} />;
}

export function HashtagsHeading({ children, data }) {
    return (
        <SectionHeading>
            <span css="display: flex; align-items: center;">
                Hashtags
                <DefinitionTooltip
                    {...tooltips.hashtags}
                    week={data?.week}
                    year={data?.year}
                    mixpanelMeta={{ contentKey: 'hashtags' }}
                    openOnClick={true}
                />
            </span>
            {children}
        </SectionHeading>
    );
}
